import { ConfirmModal } from "@/components";
import ApproverListItem from "@/components/ApproverList/ApproverListItem";
import { useToggle } from "@/hooks";
import { approvalWorkflowType } from "@/propTypes";
import {
  useDeleteApproverMutation,
  useGetApprovalWorkflowQuery,
  useGetHistoryLogsByIdQuery,
} from "@/services";
import { faArrowDown } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Space } from "antd";
import { useState } from "react";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";

const ApproverList = ({ approvalWorkflow: { id, approvers } }) => {
  const intl = useIntl();

  const [pendingItemToDelete, setPendingItemToDelete] = useState({});
  const [deleteConfirmationDialogHidden, toggleDeleteConfirmationDialogHidden] =
    useToggle(true);

  const [deleteApprover] = useDeleteApproverMutation();
  const { refetch } = useGetApprovalWorkflowQuery(id);
  const { refetch: refetchHistory } = useGetHistoryLogsByIdQuery({
    parentEntityId: id,
  });

  const handleDelete = () => {
    deleteApprover({
      approvalWorkflowId: id,
      approverId: pendingItemToDelete.id,
    })
      .unwrap()
      .then(() => {
        setPendingItemToDelete({});
        toggleDeleteConfirmationDialogHidden();
        refetch();
        refetchHistory();
        toast.success(intl.formatMessage({ id: "general.toastChangesSaved" }));
      })
      .catch(() => {
        toast.error(
          intl.formatMessage({ id: "general.toastSomethingWentWrong" })
        );
      });
  };

  const handleModalToggle = (item) => {
    setPendingItemToDelete(item);
    toggleDeleteConfirmationDialogHidden();
  };

  return (
    <>
      <Form.Item
        label={intl.formatMessage({
          id: "approvalWorkFlows.approvalFlowLabel",
        })}
        help={
          <Space size="middle">
            <FontAwesomeIcon icon={faArrowDown} />
            {intl.formatMessage({ id: "approvalWorkFlows.dependentMessage" })}
          </Space>
        }
      >
        {approvers?.map((approver) => (
          <ApproverListItem
            key={approver.id}
            header
            approver={approver}
            approvalWorkflowId={id}
            handleModalToggle={handleModalToggle}
          />
        ))}
      </Form.Item>
      <ConfirmModal
        onSaveChanges={handleDelete}
        hidden={deleteConfirmationDialogHidden}
        toggle={toggleDeleteConfirmationDialogHidden}
        headerTitleKey={"approvalWorkFlows.deleteApproverModalTitle"}
        bodyTextKey={"approvalWorkFlows.deleteApproverModalDescription"}
        confirmationTimeoutSeconds={10}
      />
    </>
  );
};

ApproverList.propTypes = {
  approvalWorkflow: approvalWorkflowType,
};

export default ApproverList;
